module.exports = __webpack_public_path__ + "static/7-a0c2dbbd301fbfd2e31964c159582f97.png";